import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledRatingLink = styled.div`
  margin-top: 18px;
  margin-bottom: 50px;

  .rating-link-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 33px;
    margin-bottom: 50px;

    .rating-link-text {
      font-size: 12px;
      line-height: 14px;
      color: ${colors.blueGray};
      width: 100%;
    }
  }
`;
